import React, { Component } from 'react';
import cn from 'classnames';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import b from 'b_';
import UrlBulkEditorCardStore from '../../stores/UrlBulkEditorCardStore';
import UrlBulkEditor from './UrlBulkEditor';
import { ConsoleCard, ConsoleCardTitle } from '../ConsoleFragments';
import UrlGuidelines from '../UrlPatternInput/UrlGuidelines';
import FuseButton from '../FuseControls/FuseButton';
import FuseConsoleCardFooter from '../ConsoleFragments/FuseConsoleCardFooter';
import DomainGuidelines from '../UrlPatternInput/DomainGuidelines';
import './UrlBulkEditorCard.css';

const block = b.lock('UrlBulkEditorCard');

class UrlBulkEditorCard extends Component {
    static propTypes = {
        store: UrlBulkEditorCardStore.PropType.isRequired,
        title: PropTypes.string,
        validUrlText: PropTypes.node,
        errorMassage: PropTypes.node,
        warningMessage: PropTypes.node,
        subTitle: PropTypes.node,
        placeholder: PropTypes.string,
        helpText: PropTypes.string,
        footerText: PropTypes.string,
        action: PropTypes.node,
        wrapperClassName: PropTypes.string,
        cardWrapperClassName: PropTypes.string,
        titleClassName: PropTypes.string,
        subtitleClassName: PropTypes.string,
        showDomainsGuidelines: PropTypes.bool,
        qa: PropTypes.string,
        legacyGuidelines: PropTypes.bool,
    };

    constructor(props) {
        super(props);
        this.cardRef = React.createRef();
    }

    componentDidMount() {
        this.props.store.urlBulkEditorStore.updateWidth(this.cardRef.current.offsetWidth);
        this.trackCardWidthInterval = setInterval(() => {
            const w = Math.max(this.cardRef.current.offsetWidth,
                this.props.store.urlBulkEditorStore.bulkEditorStore.minWidth +
                this.props.store.urlBulkEditorStore.margin);
            if (this.prevWidth !== w) {
                this.props.store.urlBulkEditorStore.updateWidth(w);
                this.prevWidth = w;
            }
        }, 100);
    }

    componentWillUnmount() {
        clearInterval(this.trackCardWidthInterval);
        if (this.props.store.guidelines.isOpen) {
            this.props.store.guidelines.close();
        }
    }

    render() {
        const { store, title, validUrlText, errorMassage, subTitle, placeholder, helpText,
            wrapperClassName, cardWrapperClassName, titleClassName, footerText,
            subtitleClassName, action, showDomainsGuidelines } = this.props;
        return <div ref={this.cardRef} className={block('Wrapper')} data-qa={this.props.qa}>
            <ConsoleCard className={cn(block('Wrapper'), wrapperClassName)}>
                { title
                    ? <ConsoleCardTitle className={cn(block('Title'), titleClassName)}>{title}</ConsoleCardTitle>
                    : null}
                <div className={block('GuideLine')}>
                    <span className={cn(block('SubTitle'), subtitleClassName)}>{subTitle}</span>
                    {!action && action !== null ? <FuseButton
                        color={'blue'}
                        icon="help_outline"
                        type={'tertiary'}
                        disabled={store.guidelines.isOpen}
                        onClick={store.guidelines.toggle}
                        qa={'help_button'}
                    >{helpText || 'URL Patterns'}</FuseButton> : null}
                </div>
                {store.guidelines.isOpen && !showDomainsGuidelines ? <UrlGuidelines
                    className={block('GuideLineInfo')}
                    onClose={store.guidelines.close}
                    legacy={this.props.legacyGuidelines}
                /> : null}
                {store.guidelines.isOpen && showDomainsGuidelines ?
                    <DomainGuidelines className={block('GuideLineInfo')} onClose={store.guidelines.close} /> : null}
                <UrlBulkEditor
                    validUrlText={validUrlText}
                    errorMassage={errorMassage}
                    placeholder={placeholder}
                    cardWrapperClassName={cardWrapperClassName}
                    store={store.urlBulkEditorStore}
                    qa={this.props.qa ? this.props.qa + '-editor' : null}
                    warningMessage={this.props.warningMessage}
                />
                {footerText ? <FuseConsoleCardFooter className={block('SectionFooter')} text={footerText} /> : null}
            </ConsoleCard>
        </div>;
    }
}

export default observer(UrlBulkEditorCard);
